import { RouterReducerState } from '@ngrx/router-store';

// eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-empty-object-type
export interface AppState {}

export const initialAppState: AppState = {};

export interface RootState {
  app: AppState;
  router: RouterReducerState;
}
